import React, { useRef, useEffect } from 'react';
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const CreateBatchAssignationForm = ({
    file,
    setFile,
    validated, 
    handleSubmit,
    uploading
    }) => {
    const inputRef = useRef(null);

    useEffect(() => {
        const focus = () => {
            if (inputRef.current) {
                inputRef.current.focus();
            }
        }
        setTimeout(focus, 100);
    }, []);

    return (
        <div className="w-100 h-100 p-4 mt-4 border customFormBox">
            <Form
                className="h-100"
                validated={validated}
                onSubmit={handleSubmit}
            >

                <Row>
                    <Form.Label>
                        Subir archivo para picking masivo
                    </Form.Label>
                </Row>
                <Row>
                    <Form.Group as={Col} sm={12}>
                        <Form.Control
                            required
                            autoFocus
                            ref={inputRef}
                            name="pickingFile"
                            type="file"
                            placeholder="Picking masivo.txt"
                            accept=".txt,.csv"
                            onChange={(event) => setFile(event.currentTarget)}
                        />
                        <Form.Text className="text-muted ms-1">
                            El archivo debe ser un <strong>.txt</strong> o <strong>.csv</strong> con la lista de 
                            <strong> SKU</strong>s,
                            <em> uno por cada línea</em>.
                        </Form.Text>
                    </Form.Group>
                </Row>

                <br />
                <br />

                <Row>
                    <Col>
                        <Button 
                            className="w-100" 
                            type="submit" 
                            variant="primary"
                            disabled={!file || uploading}
                        >
                            Subir y asignar ubicaciones
                        </Button>
                    </Col>
                </Row>
            </Form>
        </div>
    );
}
 
export default CreateBatchAssignationForm;